import React from 'react';
import PropTypes from 'prop-types';

import ReportBox from '../barbersReport/reportBox';

const DashboardRefunds = ({ totalRefunds }) => (
  <div className="layout">
    <ReportBox amount={totalRefunds} />
  </div>
);
DashboardRefunds.propTypes = {
  totalRefunds: PropTypes.number.isRequired,
};

export default DashboardRefunds;
